const resizeImage = (image, maxWidth, maxHeight, quality) => {
  const canvas = document.createElement('canvas');

  let { width } = image;
  let { height } = image;

  if (width > height) {
    if (width > maxWidth) {
      height *= maxWidth / width;
      width = maxWidth;
    }
  }
  if (height > maxHeight) {
    width *= maxHeight / height;
    height = maxHeight;
  }

  width = Math.round(width);
  height = Math.round(height);

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(image, 0, 0, width, height);
  return canvas.toDataURL('image/png', quality);
};

const srcToFile = async (src, fileName, mimeType) => {
  const res = await fetch(src);
  const buffer = await res.arrayBuffer();
  return new File([buffer], fileName, { type: mimeType });
};

export const uploadLogo = (
  file,
  {
    maxWidth = 100,
    maxHeight = 50,
    quality = 0.7,
    fileName = 'logo.jpeg',
    mimeType = 'image/jpeg',
    callback
  }
) => {
  let resizedDataUrl;
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (event) => {
    const dataUrl = event.target.result;
    const image = new Image();
    image.src = dataUrl;
    image.onload = async () => {
      resizedDataUrl = resizeImage(image, maxWidth, maxHeight, quality);
      const newFile = await srcToFile(resizedDataUrl, fileName, mimeType);
      if (callback) callback(newFile);
    };
  };
};
